import { ILandingPageData } from "@/interfaces/ILandingPage";
import styles from "./FreeEstimate.module.css";
import Image from "next/image";

type props = {
    data: ILandingPageData["freeEstimate"]
}
export function FreeEstimate({ data }: props) {
    const { headingText, subHeadingText, subHeadingText2, leadBtnText } = data;
    return (
        <section className="section">
            <div className="container1350">
                <div className={styles.getFreeesthead}>
                    <h3 className="font26 lineheightNom text222 mb20 fontSM20 mbSM15">{headingText}</h3>
                    <p className="font20 lineheightSM3 text666 fontSM14">{subHeadingText}</p>
                </div>
                <div className={styles.getMoreestimain}>
                    {
                        data.data.map((item, index) => {
                            return (
                                <div className={styles.germoEstiles} key={index}>
                                    <Image width={60} height={60} className="img-responsive" src={"/assets/images/" + item.image} alt="" />
                                    <div className={styles.getMoeintext}>
                                        <span>{item.text}</span>
                                        <p>{item.subText}</p>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
                <div className={styles.getMoestmbtbox}>
                    <span className="font26 text666 fontSM14">{subHeadingText2}</span>
                    <button className="primaryBtn" id="openExitIntentForm">{leadBtnText}</button>
                </div>
            </div>
        </section>
    )
}